export const REFERRAL_MESSAGE_STRINGS = {
  'message.success-name':
    "🎉 You're using {userName}'s referral link! This gives you",
  'message.success-expedited': ' expedited onboarding and support.',
  'message.notfound':
    '⚠️ Welcome to Belong! Unfortunately, this referral link is no longer valid.',
};
